import type { Device } from "./types";

/**
 * Which devices the Staff Terminal offers in its device picker.
 *
 * The Active check is what makes an HA-350 deactivation visible to the terminal: a revoked till
 * drops out of the picker on the next load without any separate revocation mechanism. It is only
 * half the story though — a till already signed in keeps its session, so the server-side
 * ActiveDeviceGuard is what actually refuses its work.
 */
export function isSelectableTerminalDevice(device: Device): boolean {
	return (
		(device.type === "Till" || device.type === "Tablet") &&
		device.status === "Active"
	);
}
